
import React from 'react';
import { Agent } from '../types';
import { SearchIcon, TargetIcon, GlobeIcon } from './Icons';

export const AgentCard: React.FC<{ agent: Agent; onClick: () => void; loading: boolean }> = ({ agent, onClick, loading }) => {
  let Icon = SearchIcon;
  if (agent.type === 'lead-scorer') Icon = TargetIcon;
  if (agent.type === 'researcher') Icon = GlobeIcon;

  return (
    <button
      onClick={onClick}
      disabled={loading}
      className={`relative group flex flex-col items-start p-6 rounded-[2rem] transition-all duration-500 text-left w-full overflow-hidden bdat-soft-panel-strong ${
        loading 
          ? 'border-blue-300 shadow-[0_20px_45px_rgba(49,95,244,0.12)] cursor-not-allowed grayscale-[0.15]' 
          : 'hover:border-blue-200 hover:bg-white hover:shadow-[0_24px_50px_rgba(15,23,42,0.1)] hover:-translate-y-1'
      }`}
    >
      {/* Loading Scanner Effect */}
      {loading && (
        <div className="absolute inset-0 z-0 pointer-events-none opacity-30">
           <div className="w-full h-1 bg-gradient-to-r from-transparent via-blue-500 to-transparent absolute top-0 animate-[scan_3s_infinite]"></div>
           <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(49,95,244,0.12)_0%,transparent_70%)] animate-pulse"></div>
        </div>
      )}

      <div className="relative z-10 mb-4 flex min-w-0 items-center gap-3 sm:gap-4">
        <div className={`p-3 rounded-2xl transition-all duration-500 ${
          loading ? 'bg-blue-600 text-white animate-pulse' : 'bg-blue-50 text-blue-700 group-hover:bg-blue-600 group-hover:text-white'
        }`}>
          <Icon />
        </div>
        <span className="min-w-0 break-words font-black text-slate-900 text-sm uppercase tracking-[0.16em]">{agent.name}</span>
      </div>
      
      <p className="relative z-10 max-w-full text-xs text-slate-600 leading-relaxed font-medium break-words">
        {agent.description}
      </p>

      {/* Decorative Gradient Blob */}
      <div className="absolute -bottom-10 -right-10 w-24 h-24 bg-blue-100 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity"></div>

      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes scan {
          0% { top: -10%; }
          100% { top: 110%; }
        }
      `}} />
    </button>
  );
};
